module.exports = __webpack_public_path__ + "img/peopleIcon.c912e075.svg";